// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TaskInputForm_wrapper__BuAu0","inputField":"TaskInputForm_inputField__ly8uy"};